/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsDocuments } from './HchbPatientDetailsDocuments';
import {
    HchbPatientDetailsDocumentsFromJSON,
    HchbPatientDetailsDocumentsFromJSONTyped,
    HchbPatientDetailsDocumentsToJSON,
} from './HchbPatientDetailsDocuments';
import type { HchbPatientDetailsExternalEhrPatient } from './HchbPatientDetailsExternalEhrPatient';
import {
    HchbPatientDetailsExternalEhrPatientFromJSON,
    HchbPatientDetailsExternalEhrPatientFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientToJSON,
} from './HchbPatientDetailsExternalEhrPatient';

/**
 * 
 * @export
 * @interface HchbPatientDetails
 */
export interface HchbPatientDetails {
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatient}
     * @memberof HchbPatientDetails
     */
    external_ehr_patient?: HchbPatientDetailsExternalEhrPatient;
    /**
     * 
     * @type {HchbPatientDetailsDocuments}
     * @memberof HchbPatientDetails
     */
    documents?: HchbPatientDetailsDocuments;
}

/**
 * Check if a given object implements the HchbPatientDetails interface.
 */
export function instanceOfHchbPatientDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsFromJSON(json: any): HchbPatientDetails {
    return HchbPatientDetailsFromJSONTyped(json, false);
}

export function HchbPatientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external_ehr_patient': !exists(json, 'external_ehr_patient') ? undefined : HchbPatientDetailsExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'documents': !exists(json, 'documents') ? undefined : HchbPatientDetailsDocumentsFromJSON(json['documents']),
    };
}

export function HchbPatientDetailsToJSON(value?: HchbPatientDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_ehr_patient': HchbPatientDetailsExternalEhrPatientToJSON(value.external_ehr_patient),
        'documents': HchbPatientDetailsDocumentsToJSON(value.documents),
    };
}

